import SCRPage from 'screens/SCR/SCR';

export default SCRPage;
